// eslint-disable-next-line max-classes-per-file
import React from 'react';

export enum SIZE {
    EXTRA_SMALL = 'extra-small',
    SMALL = 'small',
    MEDIUM_SMALL = 'medium-small',
    MEDIUM = 'medium',
    LARGE = 'large',
    EXTRA_LARGE = 'extra-large',
}

export enum COLOR {
    BLACK = 'black',
    WHITE = 'white',
    BLUE = 'blue',
    GRAY = 'gray',
    GRAY_DARK = 'gray-dark',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
}

export type Theme = {
    actionColor?: {
        main?: string
    }
    successColor?: {
        main?: string
    }
    errorColor?: {
        main?: string
    }
    warningColor?: {
        main?: string
    }
}

export interface IconProps {
    size?: SIZE
    color?: COLOR | string
    hoverColor?: COLOR | string
    onMouseEnter?: () => React.SyntheticEvent | undefined
    onMouseLeave?: () => React.SyntheticEvent | undefined
}

export class Add extends React.Component<IconProps> {}
export class AddCircle extends React.Component<IconProps> {}
export class AddFiled extends React.Component<IconProps> {}
export class AmericanExpress extends React.Component<IconProps> {}
export class Archive extends React.Component<IconProps> {}
export class ArrowDown extends React.Component<IconProps> {}
export class ArrowDownFull extends React.Component<IconProps> {}
export class ArrowLeft extends React.Component<IconProps> {}
export class ArrowPageLast extends React.Component<IconProps> {}
export class ArrowRight extends React.Component<IconProps> {}
export class ArrowRightFull extends React.Component<IconProps> {}
export class ArrowUp extends React.Component<IconProps> {}
export class Assistance extends React.Component<IconProps> {}
export class Bank extends React.Component<IconProps> {}
export class Bell extends React.Component<IconProps> {}
export class Block extends React.Component<IconProps> {}
export class BorderAll extends React.Component<IconProps> {}
export class Build extends React.Component<IconProps> {}
export class Burger extends React.Component<IconProps> {}
export class Card extends React.Component<IconProps> {}
export class Case extends React.Component<IconProps> {}
export class Check extends React.Component<IconProps> {}
export class CheckCircle extends React.Component<IconProps> {}
export class Chrome extends React.Component<IconProps> {}
export class ChromeColored extends React.Component<IconProps> {}
export class Close extends React.Component<IconProps> {}
export class Code extends React.Component<IconProps> {}
export class Comment extends React.Component<IconProps> {}
export class Crop extends React.Component<IconProps> {}
export class Date extends React.Component<IconProps> {}
export class Desktop extends React.Component<IconProps> {}
export class Download extends React.Component<IconProps> {}
export class Ebanx extends React.Component<IconProps> {}
export class Edit extends React.Component<IconProps> {}
export class Error extends React.Component<IconProps> {}
export class Eye extends React.Component<IconProps> {}
export class Facebook extends React.Component<IconProps> {}
export class File extends React.Component<IconProps> {}
export class Filter extends React.Component<IconProps> {}
export class Fire extends React.Component<IconProps> {}
export class FlightUp extends React.Component<IconProps> {}
export class Forth extends React.Component<IconProps> {}
export class Gamepad extends React.Component<IconProps> {}
export class Geo extends React.Component<IconProps> {}
export class GiftBox extends React.Component<IconProps> {}
export class HourGlass extends React.Component<IconProps> {}
export class InfinityIcon extends React.Component<IconProps> {}
export class InfoOutline extends React.Component<IconProps> {}
export class Insert extends React.Component<IconProps> {}
export class Instagram extends React.Component<IconProps> {}
export class Lamp extends React.Component<IconProps> {}
export class Language extends React.Component<IconProps> {}
export class LineChart extends React.Component<IconProps> {}
export class Link extends React.Component<IconProps> {}
export class Lock extends React.Component<IconProps> {}
export class LockOpen extends React.Component<IconProps> {}
export class LogOut extends React.Component<IconProps> {}
export class LpViews extends React.Component<IconProps> {}
export class Mail extends React.Component<IconProps> {}
export class Money extends React.Component<IconProps> {}
export class MoreHorizontal extends React.Component<IconProps> {}
export class MoreVertical extends React.Component<IconProps> {}
export class NoMoney extends React.Component<IconProps> {}
export class Offer extends React.Component<IconProps> {}
export class OfferFilled extends React.Component<IconProps> {}
export class OpenInNew extends React.Component<IconProps> {}
export class Pause extends React.Component<IconProps> {}
export class Paypal extends React.Component<IconProps> {}
export class Pdf extends React.Component<IconProps> {}
export class People extends React.Component<IconProps> {}
export class Phone extends React.Component<IconProps> {}
export class Pie extends React.Component<IconProps> {}
export class PieOutline extends React.Component<IconProps> {}
export class Play extends React.Component<IconProps> {}
export class Pop extends React.Component<IconProps> {}
export class Postback extends React.Component<IconProps> {}
export class Present extends React.Component<IconProps> {}
export class Propeller extends React.Component<IconProps> {}
export class Push extends React.Component<IconProps> {}
export class Qiwi extends React.Component<IconProps> {}
export class Question extends React.Component<IconProps> {}
export class Receipt extends React.Component<IconProps> {}
export class Refresh extends React.Component<IconProps> {}
export class Search extends React.Component<IconProps> {}
export class Segment extends React.Component<IconProps> {}
export class Sent extends React.Component<IconProps> {}
export class Settings extends React.Component<IconProps> {}
export class Site extends React.Component<IconProps> {}
export class Skrill extends React.Component<IconProps> {}
export class Skype extends React.Component<IconProps> {}
export class Smile extends React.Component<IconProps> {}
export class SnowFlake extends React.Component<IconProps> {}
export class Star extends React.Component<IconProps> {}
export class Stat extends React.Component<IconProps> {}
export class Stop extends React.Component<IconProps> {}
export class Support extends React.Component<IconProps> {}
export class Tablet extends React.Component<IconProps> {}
export class Target extends React.Component<IconProps> {}
export class Telegram extends React.Component<IconProps> {}
export class Tell extends React.Component<IconProps> {}
export class ThumbUp extends React.Component<IconProps> {}
export class Time extends React.Component<IconProps> {}
export class Touch extends React.Component<IconProps> {}
export class Upload extends React.Component<IconProps> {}
export class User extends React.Component<IconProps> {}
export class UserAdd extends React.Component<IconProps> {}
export class Users extends React.Component<IconProps> {}
export class Vk extends React.Component<IconProps> {}
export class Wallet extends React.Component<IconProps> {}
export class Warning extends React.Component<IconProps> {}
export class Webmoney extends React.Component<IconProps> {}
export class Wordpress extends React.Component<IconProps> {}
